import { addStyles } from 'ethcss'
import { IStyles } from 'theme'
import { colors } from 'theme'

export const otpCodeInputStyles: IStyles = {
    root: {
        position: 'relative',
        width: '100%',
        display: 'flex',
        cursor: 'text',
    },
    alignStart: {
        justifyContent: 'flex-start',
    },
    alignCenter: {
        justifyContent: 'center',
    },
    focus: {},
    error: {},
    cellError: {
        borderColor: `${colors.error} !important`,
        background: 'rgba(229, 57, 53, 0.05) !important',
        boxShadow: 'none !important',
    },
    input: {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        width: '100%',
        height: '100%',
        margin: 0,
        padding: 0,
        border: 0,
        opacity: 0,
        fontSize: 16,
        caretColor: 'transparent',
        cursor: 'text',
        zIndex: 1,
    },
    cells: {
        display: 'flex',
        flexWrap: 'nowrap',
        gap: 8,
        alignItems: 'center',
        justifyContent: 'center',
    },
    cellsAlphanumeric: {
        gap: 16,
    },
    group: {
        display: 'flex',
        flexWrap: 'nowrap',
        gap: 8,
        alignItems: 'center',
    },
    separator: {
        flexShrink: 0,
        width: 12,
        textAlign: 'center',
        fontSize: 28,
        fontWeight: 500,
        lineHeight: '36px',
        color: '#1a1a23',
        userSelect: 'none',
    },
    cell: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxSizing: 'border-box',
        width: 44,
        height: 52,
        flexShrink: 0,
        border: `1px solid rgba(26, 26, 35, 0.12)`,
        borderRadius: 12,
        background: colors.white,
        fontSize: 28,
        fontWeight: 500,
        lineHeight: '36px',
        fontVariantNumeric: 'tabular-nums',
        color: '#1a1a23',
    },
    cellFilled: {
        borderColor: colors.blueAccent,
        background: 'rgba(40, 108, 242, 0.05)',
    },
    cellCurrent: {
        borderColor: colors.blueAccent,
        background: 'rgba(40, 108, 242, 0.05)',
        boxShadow: `0 0 0 1px ${colors.blueAccent}`,
    },
}

addStyles(otpCodeInputStyles)
